import * as DestinationAlertsService from 'api/destinationAlerts'
import { API_CALL } from 'actions/actionConstants'

import {
  FETCH_HOTEL_POPULAR_HOLIDAY_TYPES,
  FETCH_POPULAR_DESTINATIONS,
  FETCH_TRENDING_DESTINATIONS,
} from 'actions/apiActionConstants'
import { getPopularDestinations } from 'api/search'
import { AppAction } from './types/ActionTypes'
import { getTrendingDestinationsCacheKey } from 'home/components/TrendingDestinations/constants'

export function fetchPopularDestinations(destinationsType: 'domestic' | 'international'): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { popularDestinations } = state.destination

    if (!popularDestinations[destinationsType].destinations && !popularDestinations[destinationsType].fetching) {
      dispatch({
        type: API_CALL,
        api: FETCH_POPULAR_DESTINATIONS,
        request: () => getPopularDestinations(destinationsType, state.geo.currentRegionCode),
        destinationsType,
      })
    }
  }
}

export function fetchTrendingDestinations(leUserId?: string, domainUserId?: string, disablePersonalisation?: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { trendingDestinationsByUserKey, fetchingTrendingDestinationsByUserKey } = state.destination

    // Create a cache key based on user IDs
    const userKey = getTrendingDestinationsCacheKey(leUserId, domainUserId, disablePersonalisation)

    // Only fetch if we don't have cached data for this user key and we're not already fetching it
    if (!trendingDestinationsByUserKey?.[userKey] && !fetchingTrendingDestinationsByUserKey?.[userKey]) {
      dispatch({
        type: API_CALL,
        api: FETCH_TRENDING_DESTINATIONS,
        request: () => DestinationAlertsService.getTrendingDestinations(state.geo.currentRegionCode, leUserId, domainUserId, disablePersonalisation),
        userKey,
      })
    }
  }
}

export function fetchHotelPopularHolidayTypes(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.destination.hotelPopularHolidayTypes.length === 0 && !state.destination.fetchingHotelPopularHolidayTypes) {
      dispatch({
        type: API_CALL,
        api: FETCH_HOTEL_POPULAR_HOLIDAY_TYPES,
        request: () => DestinationAlertsService.getHotelPopularHolidayTypes(state.geo.currentRegionCode),
      })
    }
  }
}
